window.okeReviewsWidgetOnInit = function() {
  moveWaRButton();
  
  // Observe mutations for individual reviews
  var reviewMain = document.querySelector('.js-okeReviews-reviews-main');
  if (reviewMain) {
    var reviewObserver = new MutationObserver(moveReviewComponents);
    reviewObserver.observe(reviewMain, { childList: true });
    moveReviewComponents();
  }
}

// Move WaR button next to filter
function moveWaRButton() {
  var writeReviewButton = document.querySelector('.js-okeReviews-writeReview');
  var reviewsControlsHeader = document.querySelector('.okeReviews-reviews-controls');

  if (reviewsControlsHeader && writeReviewButton && !writeReviewButton.className.includes('is-okeReviews-hiddenButton')) {
    reviewsControlsHeader.insertAdjacentElement('afterbegin', writeReviewButton);
  }
}

// Move recommendation, rating & voting elements for each review
function moveReviewComponents() {
  document.querySelectorAll('.okeReviews-reviews-review').forEach((review) => {
    var reviewRecommendation = review.querySelector('.okeReviews-review-recommendation');
    var reviewHelpful = review.querySelector('.js-okeReviews-reviewHelpful');
    var reviewPrimary = review.querySelector('.okeReviews-review-primary');

    var reviewPrimaryBottom = document.createElement('div');
    reviewPrimaryBottom.className = 'okeReviews-review-primary-bottom';

    if (reviewPrimary) {
      if (reviewRecommendation) {
      	reviewPrimaryBottom.insertAdjacentElement('beforeend', reviewRecommendation);
      }
      reviewPrimaryBottom.insertAdjacentElement('beforeend', reviewHelpful);
      reviewPrimary.insertAdjacentElement('beforeend', reviewPrimaryBottom);
    }
    
    var reviewMeta = review.querySelector('.js-okeReviews-reviewMeta');
    var reviewMainHeading = review.querySelector('.okeReviews-review-main-heading');
    
    if (reviewMainHeading) {
      reviewMainHeading.insertAdjacentElement('afterend', reviewMeta);
    }
  });
}